/**
 * Decides whether Sentry should be initialised for the current build.
 *
 * Extracted from `src/main.ts` so the rule is testable: `main.ts` is excluded
 * from coverage (`vitest.config.ts` `coverage.exclude`) and is impractical to
 * import in a unit test, so a regression in the gate would otherwise ship with
 * every check green — which is exactly what happened during the Vite cutover.
 *
 * Gate on `PROD`, never on `MODE`. Vue CLI forced `NODE_ENV=development` for
 * `vue-cli-service serve` regardless of `--mode`, so the old
 * `NODE_ENV !== 'development'` check was always false locally. Vite's `MODE`
 * tracks the `--mode` flag instead, so `pnpm start` (`vite --mode production`)
 * reports `MODE === 'production'` while still being a dev server — and because
 * `.env` carries a real DSN, that shipped local dev traffic to the live project.
 * `PROD` is derived from the command (serve vs build), which is the property
 * actually wanted here.
 */
export default function shouldInitSentry(
  env: Pick<ImportMetaEnv, 'PROD' | 'VUE_APP_SENTRY_DSN'>,
): boolean {
  return Boolean(env.PROD && env.VUE_APP_SENTRY_DSN);
}
